import { PIECE_JOINTE_TYPE_LOGO } from '@/configuration/general/pieceJointeConf';
import { pGetAllPieceJointe } from '@/api/pieceJointes';
import get from 'lodash/get';

export default async function getPiecesJointeLogoByIds(data, field = 'id') {
  if (!Array.isArray(data) || !data.length) return;
  const allPiece = (await pGetAllPieceJointe({
    elementsId: data.map(i => get(i, field)),
  })).data.result.items;
  data.forEach(m => {
    const piece = allPiece.filter(p => {
      return p.elementId === get(m, field) && p.placeType === PIECE_JOINTE_TYPE_LOGO;
    })[0];
    if (!piece) return;
    m.cheminMin = piece.cheminMin === '' ? piece.chemin : piece.cheminMin;
    m.chemin = piece.chemin;
  });
}
